// utils/passwordPolicy.js — SOURCE UNIQUE de la règle MOT DE PASSE (front).
// ────────────────────────────────────────────────────────────────────────────
// Règle STRICTEMENT IDENTIQUE au gate backend (publicAuthController / adminAuthController /
// validators.isValidPassword) : au moins 8 caractères + 1 majuscule + 1 minuscule + 1 chiffre
// + 1 caractère spécial. Garantit « accepté au front ⇒ jamais refusé au back » (et inversement).
// Remplace les vérifications divergentes (userService = longueur seule = plus FAIBLE que le back → un
// mot de passe passait le front puis était REFUSÉ au back ; formValidation partielle…).

const SPECIAL_RE = /[!@#$%^&*(),.?":{}|<>]/;

export const PASSWORD_RULES = [
  { key: 'minLength', test: (p) => p.length >= 8,        label: 'Au moins 8 caractères' },
  { key: 'upper',     test: (p) => /[A-Z]/.test(p),      label: 'Au moins 1 majuscule' },
  { key: 'lower',     test: (p) => /[a-z]/.test(p),      label: 'Au moins 1 minuscule' },
  { key: 'number',    test: (p) => /\d/.test(p),         label: 'Au moins 1 chiffre' },
  { key: 'special',   test: (p) => SPECIAL_RE.test(p),   label: 'Au moins 1 caractère spécial' },
];

/** true si le mot de passe respecte TOUTES les règles (identique au backend). */
export const isStrongPassword = (pwd) => {
  const p = String(pwd == null ? '' : pwd);
  return PASSWORD_RULES.every((r) => r.test(p));
};

/** Liste des règles NON respectées (pour un feedback UI clair). Vide = mot de passe valide. */
export const getPasswordErrors = (pwd) => {
  const p = String(pwd == null ? '' : pwd);
  return PASSWORD_RULES.filter((r) => !r.test(p)).map((r) => r.label);
};
